import React from "react";
import Slider from "react-slick";
import etiqueta1 from '../../../images/label-homeslider.svg';
import Button from "../../elements/buttons/Button";

export default function SimpleSlider() {
  var settings = {
    centerMode: true,
    arrows: false,
    pauseOnHover: false,
    dots: false,
    centerPadding: '0',
    slidesToShow: 1,
    fade: true,
    autoplay: 7000,
    speed: 2000,
    cssEase: 'linear',
    responsive: [
        {
        breakpoint: 768,
        settings: {
            arrows: false,
            dots: false,
            centerMode: true,
            pauseOnHover: false,
            centerPadding: '0',
            autoplay: 7000,
            speed: 2000,
            fade: true,
            cssEase: 'linear',
            slidesToShow: 1
        }
        }
    ]
  };
  return (
      <>
        <section className="HeroHome">
                <div className="HeroHome__caption">
                    <div className="container">
                        <div className="wrap">
                            <div className="slider__caption">
                                <img src={etiqueta1} />
                                <h2 className="titlesBig">Digitaliza tu manera de ver <br />
                                contenidos con <span>XD Neo.</span></h2>
                                <div className="HeroHome__buttons">
                                    <Button copy="Prúebalo gratis" link="/" className="button button-solid-grad-pink button-icon" />
                                    <Button copy="Suscríbete ahora" link="/" className="button-transparent" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <Slider {...settings}>
                <div>
                    <section className="HeroHome__slider" >
                    </section>
                </div>
                <div>
                    <section className="HeroHome__slider secondSlider">
                    </section>
                </div>
                <div>
                    <section className="HeroHome__slider tertiarySlider">
                    </section>
                </div>
                </Slider>
            
    </section>
    </>
  );
}